import {SIGN_TYPE, setSignType, getSignType} from './sign-type';
import navbarLoaderTemplate from '../resources/handlebars/navbar/navbar-loader.hbs';
import {USER_CONNECTED} from './events/signin';
import {SIGNUP_SELECT_IDENTITY, SIGNUP_QUALIFICATION, SIGNIN_SELECT_IDENTITY, SIGNIN_INCOMPLETE_QUALIFICATION} from './signin-signup-steps';

import './authentication/signin/form-signin';
import './authentication/signin/signin-mandatory';
import './authentication/signup/forms-signup';

import {connectedAsFreelance, connectedAsCustomer} from './authentication/identities/identity-type';
import {connectStats} from './authentication/tracking/utils';
import {extractRedirectUrl, redirectOrSendEventIfRequired} from './authentication/redirect';
import {currentLocationIs} from './authentication/helpers';
import {determineSigninUrl, determineSignupUrl} from './authentication/signin-signup-full-page';
import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

/**
 * TO READ BEFORE ANY INVOLVED MODIFICATION.
 * This script is too complex and presents serious encapsulation issues.
 * Plus, it isn't tested, although it is somewhat critical to the application.
 */

if (!window.HopConnectPopupSettings) {
    window.HopConnectPopupSettings = {
        confirmSignUp: false,
        confirmSignIn: false,
        messages: {
            authenticationError: null,
            signup: null,
            signupError: null,
        },
        tolerateUserApiUnavailability: false,
    };
}

let connectCallback;
let connectWindow;
let signSource;
Hop.connect = {};

/*
 * This code needs to be refactored but before throwing yourself in for hours, please
 * read this :
 * - Since this code is supposed to be executed on every page, one cannot put it in a hopModule and hope for the best
 * because you'll have no markup to attach it to
 * - If you manage to attach it to a markup, you will now have to rewrite *EVERY* selector using the $root relative :)
 * - Finally, you will be able to use it as a regular module (with regular translation mechanisms)
 *
 * Why did I didn't do it ? I am not hairy enough in JS to do it effectively without breaking everything :(
 */
$(document).ready(() => {
    $('#signupModal').on('hide.bs.modal', () => {
        $('.modal-backdrop').remove();
    });

    $('#signupModal, #signinModal').on('hide.bs.modal', () => {
        if (connectCallback) {
            eval(connectCallback);
            // it looks like 'hide.bs.modal' is triggered even when modal is already hidden
            // let's avoid a second execution of the callback
            connectCallback = null;
        }
    });

    Hop.connect.connectWithSocialPopup = function ($socialForm) {
        connectWindow = window.open('', 'connectWindow', 'width=600,height=405');
        const cTP = $socialForm;
        cTP[0].setAttribute('target', 'connectWindow');
        cTP[0].submit();
    };

    $(document).on('click', '.modal [name="socialButton"]', (event) => {
        event.preventDefault();

        Hop.connect.onSocialPopupClose = function () {
            Hop.connect.control.popupClosed();
        };

        Hop.connect.popupCloseSocialWithError = function (code) {
            window.location = '/signin?error=' + code;
        };

        Hop.connect.connectWithSocialPopup($(event.currentTarget).parents('form'));
    });

    $(document).on('click', "[name='socialButton']", (e) => {
        const $button = $(e.target);
        const $form = $button.parents('form');

        setSignType($form.attr('data-sign-type'));
        signSource = $form.attr('data-sign-source');

        if (window.SIGN_UP_GTM_ENABLED && $form.attr('data-gtm-form-signup')) {
            Hop.gtm.push(JSON.parse($form.attr('data-gtm-form-signup')));
        }
    });

    $(document).on('submit', 'form.signin-mandatory', function (e) {
        // eslint-disable-next-line no-invalid-this
        const el = this;
        const $el = $(el);

        $el.data('hop-can-submit', true);

        if ($el.data('hop-connected') === true) {
            // allow default action
            return;
        }

        e.preventDefault();
        if (Hop.hasFormValidation()) {
            if (el.checkValidity()) {
                Hop.connect.control.showSigninPopup($el, false);
            }
        } else {
            Hop.connect.control.showSigninPopup($el, false);
        }
    });
});

function triggerQualificationModal(step, userInfo, redirectUrl = null, onDone = null) {
    const closeable = !(step === SIGNUP_SELECT_IDENTITY || step === SIGNUP_QUALIFICATION);
    const opts = {
        show: true,
        keyboard: closeable,
        backdrop: !closeable ? 'static' : true,
    };

    if (onDone) {
        Hop.events.on('signup-confirm:closed', () => {
            onDone();
        });
    }

    const $modal = $('#confirmSignupModal');

    $modal.attr('data-closeable', closeable);
    $modal.attr('data-redirect', redirectUrl);
    $modal.attr('data-qualification', step);

    const clientData = userInfo && userInfo.client;
    if (clientData) {
        $modal.attr('data-client', JSON.stringify(clientData));
    }

    connectCallback += `;$('#confirmSignupModal').modal(${JSON.stringify(opts)});`;
}

// shown.bs.modal won't trigger, not idea why, thus the (dirty) use of show.bs.modal + setTimeout
function focusUsernameWhenShown($modal) {
    $modal.one('show.bs.modal', () => {
        setTimeout(() => {
            $modal.find('[name="email"]').trigger('focus');
        }, 200);
    });
}

Hop.defineModule('forms.pwdrenewal', (root, param) => {
    const $root = $(root);

    const $request = $root.find('#pwdRenewalRequest');
    const $confirm = $root.find('#pwdRenewalConfirm');
    const $msg = $confirm.find('p');
    const $link = $confirm.find('a');

    function showConfirm(success, email) {
        $request.toggleClass('hidden', true);
        $confirm.toggleClass('hidden', false);

        if (success) {
            $msg.text(Hop.messageTemplate(param.renewSendSuccess, email));
        } else {
            $msg.text(param.renewSendFailed);
        }
    }

    function sendRenewalPwd() {
        const email = $root.find('[name=email]').val();
        const pendingAccountId = $root.find('[name=pendingAccountId]').val();
        const useCase = $root.find('[name=useCase]').val();
        const request = $.ajax({
            url: '/api/pwdrenewal',
            type: 'POST',
            data: JSON.stringify({
                email,
                pendingAccountId,
                useCase,
            }),
            contentType: 'application/json',
        });
        request.done(() => {
            showConfirm(true, email);
        });
        request.fail(() => {
            showConfirm(false);
        });
    }

    const submitRenewalPwd = (e) => {
        e.preventDefault();
        sendRenewalPwd();
    };

    $link.on('click', (e) => {
        if (!e.target.hasAttribute('data-allow-click')) {
            e.preventDefault();
            $root.find('form').off('submit', submitRenewalPwd);
            $('#pwdRenewalModal').modal('hide');
            const $modal = $('#signinModal');
            focusUsernameWhenShown($modal);
            $modal.modal('show');
        }
    });

    const initPwdResetModal = (event) => {
        $root.find('#formPwdRenewal').on('submit', submitRenewalPwd);

        const button = $(event.relatedTarget);
        const emailFieldId = button.data('email-field-id');
        const $existingEmailField = $(`#${emailFieldId}`);

        if ($existingEmailField) {
            const email = $existingEmailField.val();
            if (email && (!$existingEmailField[0].checkValidity || $existingEmailField[0].checkValidity())) {
                $root.find('[name="email"]').val(email);
                $root.find('form').submit();
                return;
            }
        }

        $request.toggleClass('hidden', false);
        $confirm.toggleClass('hidden', true);

        setTimeout(() => {
            $root.find('[name=email]').trigger('focus');
        }, 200);
    };

    // Dirty hack : find another way to intercept unload event of the data js module
    // This module is initiated every time the modal is shown
    $('#pwdRenewalModal').off('show.bs.modal');
    $('#pwdRenewalModal').on('show.bs.modal', initPwdResetModal);
});

function initPwdRenewalModal() {
    const $pwdRenewalModal = $('#pwdRenewalModal');
    if ($pwdRenewalModal && $pwdRenewalModal.length) {
        Hop.control.init($pwdRenewalModal[0]);
    }
}

function nextStep(userInfo, isFreelance, isClient) {
    if (isFreelance) {
        return null;
    }

    const connectionSettings = window.HopConnectPopupSettings;
    if (!connectionSettings.confirmSignIn) {
        return null;
    }

    const isUndefined = !isClient && !isFreelance;
    if (isUndefined) {
        return SIGNIN_SELECT_IDENTITY;
    }

    const isClientComplete = isClient && (!userInfo.client || userInfo.client.completed);
    if (!isClientComplete) {
        return SIGNIN_INCOMPLETE_QUALIFICATION;
    }

    return null;
}

function removeNavbarUnloggedAttrs() {
    document.body.classList.remove('navbar-unlogged');
    document.body.classList.remove('WITH_SEARCH_FORM');
}

(function ($, win, doc, Hop) {
    const Control = function () {
        this.init();

        // must be initialized before being shown
        initPwdRenewalModal();
    };
    Control.prototype = {
        init: function () {
            this.id = 'connectControl';
            this.tag = null;
        },
        testConnected: function () {
            const dfd = jQuery.Deferred();
            $.ajax({
                url: '/api/user/connected',
                type: 'GET',
                cache: false,
            })
                .done((connected) => {
                    dfd.resolve(connected);
                })
                .fail((jqXHR, textStatus) => {
                    pushNotification(`${window.HopConnectPopupSettings.messages.signupError}: ${textStatus} - ${jqXHR.responseText}`, {
                        level: 'error',
                    });
                });
            return dfd.promise();
        },

        configureModalInvitationPopupAfterSignin: function (invitationModalData) {
            $('#invitationModal').attr('data-company-name', invitationModalData.companyName);
            $('#invitationModalForm').attr('action', invitationModalData.companyInvitationUrl);
            if (!invitationModalData.canInviteMembersAsAdmin) {
                $('#addAdminRole').addClass('hidden');
            }
            $('#invitationMessage').attr(
                'placeholder',
                Hop.message('company.invitation.modal.add.message.placeholder', invitationModalData.companyName),
            );
        },

        updateHeaderWithNavbarLoader: function (navbarDisplayMode) {
            const $navbar = document.querySelector('#navbar');
            const $headerWrapperV2 = document.querySelector('[data-testid="header-wrapper-v2"]');

            // Add new navbar placeholder / skeletons
            if ($navbar) {
                const isNavbarFull = navbarDisplayMode === 'FULL';
                if (isNavbarFull) {
                    document.documentElement.style.setProperty('--layout-padding-left', '264px');
                }
                $navbar.classList.add(isNavbarFull ? 'navbar_full' : 'navbar_reduced');
                $navbar.innerHTML = navbarLoaderTemplate({navbarDisplayMode});
            }

            removeNavbarUnloggedAttrs();

            // Remove old header
            if ($headerWrapperV2) {
                $headerWrapperV2.remove();
            }
        },

        updateOldHeader: function (userInfo) {
            $('.not-connected-link').hide();
            $('.connected-link').removeClass('hide').show();
            if (userInfo.identities && userInfo.identities.length) {
                $('.connected-wo-company-lnk').hide();
                $('.connected-w-company-lnk').removeClass('hide').show();
            } else {
                $('.connected-wo-company-lnk').removeClass('hide').show();
                $('.connected-w-company-lnk').hide();
            }
            if (userInfo.profileId) {
                $('.connected-wo-profile-lnk').hide();
                $('.connected-w-profile-lnk').removeClass('hide').show();
            } else {
                $('.connected-w-profile-lnk').hide();
                $('.connected-wo-profile-lnk').removeClass('hide').show();
            }
        },

        fetchUserInfoAndClosePopup: function () {
            const self = this;

            $.ajax({
                url: '/api/user?header=true&location=' + encodeURIComponent(window.location.pathname + window.location.search),
                type: 'GET',
                cache: false,
                dataType: 'json',
                success: function (userInfo) {
                    Hop.events.trigger(USER_CONNECTED, userInfo);

                    // Used in navbar-app, needs to be set before triggering "user:connected" event
                    window.navbarDisplayMode = userInfo.header?.navbarDisplayMode || 'REDUCED';

                    // We need "user:connected" event in the Micro-Frontend starter
                    // And we can't rely on Hop.events because the Hop object might not be ready yet in the Micro-Frontend starter
                    window.dispatchEvent(new CustomEvent('user:connected'));

                    if (self.tag && self.tag.attr('data-callback')) {
                        connectCallback += self.tag.attr('data-callback');
                    }

                    const isSignUp = getSignType() === SIGN_TYPE.SIGNUP;
                    const connectionSettings = window.HopConnectPopupSettings;
                    const doNotSkipSignUpConfirmation = self.tag && typeof self.tag.attr('data-no-confirm-signup-modal') !== 'string';
                    if (isSignUp && doNotSkipSignUpConfirmation) {
                        if (currentLocationIs('/project/new')) {
                            connectCallback = '';
                        } else {
                            if (connectionSettings.confirmSignUp) {
                                // New modal, disabled for some specific pages (so the `confirmSignUp` flag).
                                triggerQualificationModal(SIGNUP_SELECT_IDENTITY, userInfo, extractRedirectUrl(self.tag));
                            }
                        }
                    }

                    if (!connectCallback) {
                        const refreshAfterConnect = window.REFRESH_AFTER_CONNECT || userInfo.likelyAnAdmin;
                        const isFreelance = connectedAsFreelance(userInfo);
                        const isCustomer = connectedAsCustomer(userInfo);

                        const isSignIn = getSignType() === SIGN_TYPE.SIGNIN;
                        const doNotSkipQualification = self.tag && typeof self.tag.attr('data-no-confirm-signin-modal') !== 'string';
                        const qualificationStep = doNotSkipQualification ? nextStep(userInfo, isFreelance, isCustomer) : null;
                        if (isSignIn && qualificationStep) {
                            const redirectUrl = extractRedirectUrl(self.tag);
                            const onDone = connectCallback
                                ? null
                                : () => redirectOrSendEventIfRequired(self.tag, isFreelance, isCustomer, refreshAfterConnect);

                            triggerQualificationModal(qualificationStep, userInfo, redirectUrl, onDone);
                        } else {
                            redirectOrSendEventIfRequired(self.tag, isFreelance, isCustomer, refreshAfterConnect);
                        }
                    }

                    $('#signupModal').modal('hide');
                    $('#signinModal').modal('hide');

                    if (self.tag && self.tag.attr('data-modal')) {
                        $('#' + self.tag.attr('data-modal') + 'SignupModal').modal('hide');
                        $('#' + self.tag.attr('data-modal') + 'SigninModal').modal('hide');
                    }

                    if (userInfo.header) {
                        const invitationModalData = userInfo.invitationModalData;
                        if (invitationModalData) {
                            self.configureModalInvitationPopupAfterSignin(invitationModalData);
                        }
                        self.updateHeaderWithNavbarLoader(userInfo.header.navbarDisplayMode);
                    } else {
                        self.updateOldHeader(userInfo);
                    }

                    if (connectWindow && connectWindow.close) {
                        connectWindow.close();
                    }
                },
            });
        },

        popupClosed: function (isFormSignup) {
            const self = this;
            $.ajax({
                url: '/api/user/connected',
                type: 'GET',
                cache: false,
            })
                .done((isConnected) => {
                    if (isConnected) {
                        connectStats(isFormSignup, self.tag, signSource);
                        self.fetchUserInfoAndClosePopup();
                    } else {
                        pushNotification(window.HopConnectPopupSettings.messages.authenticationError, {level: 'error'});
                        if (connectWindow && connectWindow.close) {
                            connectWindow.close();
                        }
                    }
                })
                .fail((jqXHR, textStatus) => {
                    pushNotification(`${window.HopConnectPopupSettings.messages.signupError}: ${textStatus} - ${jqXHR.responseText}`, {
                        level: 'error',
                    });
                    if (connectWindow && connectWindow.close) {
                        connectWindow.close();
                    }
                });
        },
        connectionHandler: function (tag) {
            if (tag.is('.not-connected-link')) {
                this.fetchUserInfoAndClosePopup();
            } else if (tag.attr('data-callback')) {
                eval(tag.attr('data-callback'));
            } else {
                redirectOrSendEventIfRequired(tag);
            }
        },
        showSigninPopup: function (tag, signupFirst = false, options = {redirectToSigninSignupPagesIfEnabled: true}) {
            if (!(tag instanceof jQuery)) {
                tag = $(tag);
            }

            const domTag = tag instanceof jQuery ? tag[0] : tag;
            connectCallback = ''; // Reset. Empty string intended, for later concatenation

            // Skip connection check as request and execute connection handler
            if (tag.data('is-connected')) {
                this.connectionHandler(tag);
                return;
            }

            const self = this;
            self.tag = tag;
            self.domTag = domTag;
            $.ajax({
                url: '/api/user/connected',
                type: 'GET',
                cache: false,
            })
                .done((isConnected) => {
                    if (isConnected) {
                        self.connectionHandler(tag);
                    } else {
                        const userNameEl = document.querySelector('#signup_username');
                        if (signupFirst || tag.attr('data-firstName') || tag.attr('data-show-signup-first')) {
                            if (options.redirectToSigninSignupPagesIfEnabled) {
                                const signupUrl = determineSignupUrl(domTag);
                                if (signupUrl) {
                                    window.location.assign(signupUrl);
                                    return;
                                }
                            }

                            setSignType(SIGN_TYPE.SIGNUP);

                            const $modal = tag.attr('data-modal') ? $('#' + tag.attr('data-modal') + 'SignupModal') : $('#signupModal');
                            $modal.modal('show');
                        } else {
                            if (options.redirectToSigninSignupPagesIfEnabled) {
                                const signinUrl = determineSigninUrl(domTag);
                                if (signinUrl) {
                                    window.location.assign(signinUrl);
                                    return;
                                }
                            }

                            const $modal = tag.attr('data-modal') ? $('#' + tag.attr('data-modal') + 'SigninModal') : $('#signinModal');
                            focusUsernameWhenShown($modal);
                            $modal.modal('show');

                            setSignType(SIGN_TYPE.SIGNIN);
                        }
                        if (tag.attr('data-firstName')) {
                            if (tag.attr('data-showName') && tag.attr('data-showName') !== 'true') {
                                $('#signup_firstName').hide();
                            }
                            const firstNameEl = document.querySelector('#signup_firstName');
                            if (firstNameEl) {
                                firstNameEl.value = domTag.getAttribute('data-firstName');
                                Hop.nativeTrigger(firstNameEl, 'input');
                            }
                        } else {
                            const $firstNameInput = $('#signup_firstName').removeClass('hide').show();
                            setTimeout(() => {
                                $firstNameInput.trigger('focus');
                            }, 200);
                        }

                        if (tag.attr('data-lastName')) {
                            if (tag.attr('data-showName') && tag.attr('data-showName') !== 'true') {
                                $('#signup_lastName').hide();
                            }
                            const lastNameEl = document.querySelector('#signup_lastName');
                            if (lastNameEl) {
                                lastNameEl.value = domTag.getAttribute('data-lastName');
                                Hop.nativeTrigger(lastNameEl, 'input');
                            }
                        } else {
                            $('#signup_lastName').removeClass('hide').show();
                        }

                        if (userNameEl && !userNameEl.value && typeof domTag.getAttribute === 'function') {
                            userNameEl.value = domTag.getAttribute('data-email');
                            Hop.nativeTrigger(userNameEl, 'input');
                        }
                        if (tag.attr('data-message')) {
                            $('#signup-message').text(tag.attr('data-message'));
                        } else {
                            $('#signup-message').parent().parent().hide();
                        }

                        if (tag.attr('data-title')) {
                            $('#signupModalTitle').html(tag.attr('data-title'));
                        } else {
                            $('#signupModalTitle').html(window.HopConnectPopupSettings.messages.signup);
                        }

                        if (tag.attr('data-title-signin')) {
                            $('#signinModalTitle').html(tag.attr('data-title-signin'));
                        } else {
                            $('#signinModalTitle').html(window.HopConnectPopupSettings.messages.signin);
                        }

                        $('#signinModal .modal-footer').toggle(typeof self.tag.attr('data-noswitch') !== 'string');
                    }
                })
                .fail((jqXHR, textStatus) => {
                    if (window.HopConnectPopupSettings.tolerateUserApiUnavailability) {
                        console.error(
                            'Tolerating User API unavailability and pretending use is indeed connected.\n' +
                                `Following error is ignored: ${textStatus}: ${jqXHR.responseText}`,
                        );
                        self.connectionHandler(tag);
                    } else {
                        pushNotification(`${window.HopConnectPopupSettings.messages.signupError}: ${textStatus} - ${jqXHR.responseText}`, {
                            level: 'error',
                        });
                    }
                });
        },
    };

    Hop.connect.control = Hop.storeObj(new Control());

    Hop.connect.popupCloseSocial = function () {
        if (typeof Hop.connect.onSocialPopupClose === 'function') {
            Hop.connect.onSocialPopupClose();
            if (connectWindow && connectWindow.close) {
                connectWindow.close();
            }
        } else {
            Hop.connect.control.popupClosed();
        }
    };
})(jQuery, window, document, (window.Hop = window.Hop || {}));
